import classNames from "classnames"
import React, { HTMLAttributes } from "react"
import { FunctionComponent } from "react"

import * as styles from "./layouts.module.scss"

export const CenterLayout: FunctionComponent<
    HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...props }) => (
    <div {...props} className={classNames(styles.center, className)}>
        {children}
    </div>
)
